import React, {useState} from 'react';
import { Users } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const ExampleTeam = ({ onPreview }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedTeamId] = useState(null);

  const exampleTeam = {
    id: 'example-team',
    name: t('example.team.name'),
    employees: [
      {
        name: "John Smith",
        number: 101,
        wkl_Wrk_Load: 400,  
        day_WI: 80,         
        at_Roster_Num: 1
      },
      {
        name: "Sarah Johnson",
        number: 102,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      },
      {
        name: "Anna Brown",
        number: 103,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      },
      {
        name: "Dwyane Wade",
        number: 104,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      },
      {
        name: "Michael Porter",
        number: 105,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      },
      {
        name: "Kobe James",
        number: 106,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      },
      {
        name: "Larry Bird",
        number: 107,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      },
      {
        name: "Marvin Williams",
        number: 108,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      },
      {
        name: "Derrick Rose",
        number: 109,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      },
      {
        name: "Thomas Jones",
        number: 110,
        wkl_Wrk_Load: 400,
        day_WI: 80,
        at_Roster_Num: 1
      }
    ]
  };

  const handleSelect = () => {
    const formattedEmployees = exampleTeam.employees.map(emp => ({
        name: emp.name,
        wkl_wrk_load: emp.wkl_Wrk_Load, 
        day_WI: emp.day_WI,
        at_roster_num: emp.at_Roster_Num, 
        number: emp.number,
        team: 1 
      }));
    
    sessionStorage.setItem('employees', JSON.stringify(formattedEmployees));
   
    navigate('/form/general', {
      state: { isExample: true }
    });
  };

  return (
    <div 
      key={exampleTeam.id}
      className={`bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 ease-in-out transform hover:-translate-y-1 relative
      ${selectedTeamId === exampleTeam.id.toString() ? 'border-2 border-indigo-600' : ''}
      ${exampleTeam.source ? 'ring-1 ring-indigo-200' : ''}`}
    >
      {selectedTeamId === exampleTeam.id.toString() && (
        <div className="absolute top-2 right-2 bg-indigo-600 text-white rounded-full p-1">
          <Check className="w-4 h-4" />
        </div>
      )}
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4">
            <div className="bg-indigo-100 p-3 rounded-full">
              <Users className="w-6 h-6 text-indigo-600" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-gray-900">
                {exampleTeam.name}                
              </h3>
              <p className="text-sm text-gray-500">
                {exampleTeam.employees.length} {t('teams.count')}{exampleTeam.employees.length !== 1 ? 's' : ''}
              </p>
            </div>
          </div>
        </div>
        <div className="flex justify-between items-center mt-4 pt-4 border-t">
          <button
            onClick={() => onPreview(exampleTeam)}
            className="px-4 py-2 text-indigo-600 border border-indigo-600 rounded-lg hover:bg-indigo-50 transition-colors mr-1"
          >
            {t("form.employee.preview")}
          </button>
          <button
            onClick={() => handleSelect(exampleTeam)}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 transition-colors"
          >
            {t("form.employee.select")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExampleTeam;